
export class RequestShipmentModel {
    RequestShipmentId: number;
    RequestId: number;
    RecipientId: number;
    AddressId: number;
}